interface InstallHintConditions {
  isIosSafari: boolean;
  isInStandaloneMode: boolean;
  isDismissed: boolean;
}

/**
 * iOS Safari has no install prompt API, so a hint is the only way users find
 * "Add to Home Screen". It is pointless once the app already runs from the
 * home screen, and it never comes back after the user closes it.
 */
export default function shouldShowInstallHint({
  isIosSafari,
  isInStandaloneMode,
  isDismissed,
}: InstallHintConditions): boolean {
  return isIosSafari && !isInStandaloneMode && !isDismissed;
}
